// ====================
// ⚙ Gcbs Configuration
// Make all necessary settings for GCBS.
// Make all the necessary adjustments after having executed the configuration file by environment.
// ====================
(function() {
  'use strict';

  /**
   * Disable all logs for the production environment.
   */
  function disableLogs() {
    const { environment } = { ...window.appProperties };
    if (environment === 'pro') {
      [
        'assert', 'clear', 'count', 'countReset', 'debug', 'dir', 'dirxml', 'error', 'exception',
        'group', 'groupCollapsed', 'groupEnd', 'info', 'log', 'markTimeline', 'profile', 'profileEnd',
        'table', 'time', 'timeEnd', 'timeline', 'timelineEnd', 'timeLog', 'timeStamp', 'trace', 'warn'
      ].forEach(method => (window.console[method] = () => undefined));
    }
  }

  /**
   * Clean from the AppConfig object (Cells Settings), data that is garbage.
   */
  function cleanAppConfig() {
    delete window.AppConfig.appConfig;
    delete window.AppConfig.appPages;
    delete window.AppConfig.appProperties;
  }

  const { appConfig, appProperties, appPages } = { ...window.AppConfig };

  // 🧞 GCBS Global
  window.GCBS = {
    /**
     * Settings such as roles, headers, etc.
     */
    ...appConfig,
    /**
     * Properties for the application
     */
    props: {
      ...window.GCBS.props,
      ...appProperties
    },
    /**
     * Path to your pages.
     * This object contains the valid pages to navigate. Use it with `this.navigate()`.
     */
    pages: appPages
  };

  // 🙈 Disable all console for production
  disableLogs();

  // 🧽 Clean App Config
  cleanAppConfig();
}());
